import { PlanTypes } from "@/types";
import { request } from "./request";

/**
 * Search Plans
 * @param {string | {plan_name_or_client_id: string}} payload - Plan name, or an object with a plan name or client id for a fuzzy search
 * @param authToken Authorization token header to be added to make the call
 * @returns The list of plans filtered by the optionally specified filter.
 */
export async function getPlanList(
  data: { plan_name_or_client_id: string },
  authToken: string,
): Promise<PlanTypes.PlanSearchResponse> {
  const response = await request<PlanTypes.PlanSearchResponse>(
    {
      url: "/plan/list",
      method: "POST",
      data,
    },
    authToken,
  );

  return response;
}
